// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"MatchStandings_sectionWrapper__VR81P","container":"MatchStandings_container__FJu6e"};